export enum ApplicationStage {
  Applied = 1,
  Screened = 2,
  Candidate = 3,
  Hired = 4,
  Rejected = 5,
}

export function getApplicationStageLabel(stage: ApplicationStage): string {
  switch (stage) {
    case ApplicationStage.Applied:
      return "Applied";
    case ApplicationStage.Screened:
      return "Screened";
    case ApplicationStage.Candidate:
      return "Candidate";
    case ApplicationStage.Hired:
      return "Hired";
    case ApplicationStage.Rejected:
      return "Rejected";
    default:
      return "Unknown";
  }
}

export function getApplicationStageBadgeVariant(
  stage: ApplicationStage,
): "default" | "secondary" | "destructive" | "outline"|"success" {
  switch (stage) {
    case ApplicationStage.Applied:
      return "secondary";
    case ApplicationStage.Screened:
      return "outline";
    case ApplicationStage.Candidate:
      return "default";
    case ApplicationStage.Hired:
      return "success";
    case ApplicationStage.Rejected:
      return "destructive";
    default:
      return "secondary";
  }
}
